import { type GroupOrderJoinPreviewQuery } from '../graphql/GroupOrderJoin.generated';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfDeliveryGroupOrder(params: CheckIfDeliveryGroupOrderParams) {
  const { preview } = params;

  const typename = preview?.__typename;

  return typename === 'MultipartyOrderPreviewSuccess' && Boolean(preview?.deliveryAddressSummary);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderPreview = GroupOrderJoinPreviewQuery['multipartyOrderPreview'];
type CheckIfDeliveryGroupOrderParams = { preview: GroupOrderPreview | undefined };
